import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import uk from './locales/uk.json';
import ro from './locales/ro.json';
import be from './locales/be.json';

const resources = {
  en: {
    translation: en
  },
  uk: {
    translation: uk
  },
  ro: {
    translation: ro
  },
  be: {
    translation: be
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // Англійська як fallback
    
    interpolation: {
      escapeValue: false, // React уже захищений від XSS
      skipOnVariables: false,
      prefix: '{',
      suffix: '}',
      formatSeparator: ',',
      format: function(value, format, lng) {
        if (format === 'number') return new Intl.NumberFormat(lng).format(value);
        return value;
      }
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    },
    
    // Налаштування для кращої роботи з невизначеними ключами
    debug: false,
    returnEmptyString: false,
    returnNull: false,
    returnObjects: false,
    
    // Налаштування для множинних форм
    pluralSeparator: '_',
    contextSeparator: '_',
    
    // Налаштування для кешування
    saveMissing: false,
    missingKeyHandler: function(lngs: readonly string[], _ns: string, key: string, _fallbackValue: string, _updateMissing: boolean, _options: any) {
      if (process.env.NODE_ENV === 'development') {
        console.warn(`Missing translation key: ${key} for languages: ${lngs.join(', ')}`);
      }
    },
    
    // Дозволяємо безпечне використання HTML в перекладах
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'em', 'span']
    }
  });

export default i18n;

// Список доступних мов
export const languages = [
  { code: 'uk', name: 'Українська', flag: '🇺🇦' },
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' },
  { code: 'be', name: 'Беларуская', flag: '🇧🇾' }
];

// Функція для зміни мови
export const changeLanguage = (lng: string) => {
  i18n.changeLanguage(lng);
};

// Функція для отримання поточної мови
export const getCurrentLanguage = () => {
  return i18n.language;
};

// Функція для отримання назви мови
export const getLanguageName = (code: string) => {
  const lang = languages.find(l => l.code === code);
  return lang ? lang.name : code;
}; 